import React, { Component } from 'react';
import {
   Card, CardBody, Col, Table, Button, Badge, UncontrolledTooltip,
} from 'reactstrap';
import swal from 'sweetalert';
import { withTranslation } from 'react-i18next';
import CommonService from '../../../services/CommonService';

class IncidentReport extends Component {
   constructor() {
      super();
      this.state = {
         list: [],
      };
      this.isLoading = false;
      this.userdata = JSON.parse(localStorage.getItem('userData'));
   }

   componentDidMount() {
      this.isLoading = true;
      this.onLoadData();
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   onLoadData = async () => {
      try {
         let location = '';
         if (this.userdata.type !== '1' && this.userdata.type !== '5') {
            location = `/locationid/${this.userdata.location_id}`;
         }
         const response = await CommonService.getRows(`reports${location}`);
         if (this.isLoading) {
            this.setState({ list: response });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   confirmReport = (e, stockId, status) => {
      e.preventDefault();
      const { list } = this.state;
      swal({
         title: 'Confirmation',
         text: 'Are you sure you want to confirm this report?',
         icon: 'warning',
         buttons: {
            yes: 'YES',
            no: 'NO',
         },
         dangerMode: true,
         closeOnClickOutside: false,
      }).then((btnName) => {
         btnName = btnName.toLowerCase();

         if (btnName === 'yes') {
            const formdata = {
               currentStatus: status,
               stockId,
            };
            CommonService.updateData('updatereportstatus', formdata).then((response) => {
               if (response === true) {
                  list.filter((listResp) => {
                     if (listResp.stock_id === stockId) {
                        listResp.report_status = 1;
                     }
                     return listResp;
                  });
                  this.setState({ list });
                  swal('', 'Successfully confirmed incident report!', 'success');
               } else {
                  swal('', 'Failed to confirm incident report!', 'danger');
               }
            });
         }
      });
   }

   render() {
      const { list } = this.state;

      return (
         <Col md={12}>
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">Incident Report</h5>
                  </div>
                  <div className="panel__content">
                     <Table responsive striped className="doResTable">
                        <thead>
                           <tr>
                              <th>RF #</th>
                              <th>Product Name</th>
                              <th>From</th>
                              <th>To</th>
                              <th className="text-center">Quantity</th>
                              <th className="text-center">Actual Quantity</th>
                              <th className="text-center" width="20%">Note</th>
                              <th className="text-center">Date</th>
                              <th className="text-center">Status</th>
                              <th className="text-center">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {
                              list !== false || list.length > 0 ? list.map((item, i) => {
                                 item.report_status = parseInt(item.report_status, 10);
                                 let status = 'For Confirmation';
                                 let badgeColor = 'danger';
                                 if (item.report_status === 1) {
                                    status = 'Confirmed';
                                    badgeColor = 'success';
                                 }

                                 return (
                                    <tr key={`report_tr${i + 1}`} className="text-center">
                                       <td className="text-left">{item.delivery_number}</td>
                                       <td className="text-left">{item.product_name}</td>
                                       <td className="text-left">{item.location_from_name}</td>
                                       <td className="text-left">{item.location_to_name}</td>
                                       <td>{item.quantity_out ? item.quantity_out : 0}</td>
                                       <td>{item.quantity_in ? item.quantity_in : 0}</td>
                                       <td className="white-space-pre-wrap">{item.note ? item.note : '-'}</td>
                                       <td>{item.report_date ? item.report_date : '-'}</td>
                                       <td><Badge color={badgeColor}>{status}</Badge></td>
                                       <td className="ab">
                                          {
                                             item.report_status === 0 ? (
                                                <>
                                                <Button color="success" className="btn-xs" onClick={e => this.confirmReport(e, item.stock_id, status)} id={`confirmbtn${i + 1}`} outline><span className="fa fa-check" /></Button>
                                                <UncontrolledTooltip placement="bottom" target={`confirmbtn${i + 1}`}>Confirm</UncontrolledTooltip>
                                                </>
                                             ) : '-'
                                          }
                                       </td>
                                    </tr>
                                 );
                              }) : (
                                 <tr className="text-center">
                                    <td colSpan="11">No data available..</td>
                                 </tr>
                              )
                           }
                        </tbody>
                     </Table>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(IncidentReport);
